import { PropertyCategory } from "../../../@types/CapioWeb/core"

const onlyUnique = <T>(value: T, index: number, self: T[]) =>
	self.indexOf(value) === index

export const resolveFilterItems = (
	list: PropertyCategory
): string[] => {
	return list
		.value.map((category) => category.description)
		.filter(onlyUnique)
}
